import { useState } from 'react'
import { api, setTokens } from '../api'

export default function LoginPage({ onLogin }) {
  const [userId, setUserId] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  // 비밀번호 변경 모드
  const [changePw, setChangePw] = useState(false)
  const [changePwUser, setChangePwUser] = useState(null)
  const [currentPw, setCurrentPw] = useState('')
  const [newPw, setNewPw] = useState('')
  const [newPwConfirm, setNewPwConfirm] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!userId.trim() || !password.trim()) {
      setError('사번과 비밀번호를 입력하세요.')
      return
    }
    setError('')
    setLoading(true)
    try {
      const res = await api.login(userId.trim(), password.trim())
      if (res.must_change_password) {
        setChangePw(true)
        setChangePwUser(res)
        setCurrentPw(password.trim())
        return
      }
      setTokens(res.token, res.refresh_token, res.user)
      onLogin(res.user)
    } catch (err) {
      setError(err.message || '로그인에 실패했습니다.')
    } finally {
      setLoading(false)
    }
  }

  const handleChangePassword = async (e) => {
    e.preventDefault()
    if (!newPw.trim()) { setError('새 비밀번호를 입력하세요.'); return }
    if (newPw !== newPwConfirm) { setError('새 비밀번호가 일치하지 않습니다.'); return }
    setError('')
    setLoading(true)
    try {
      const res = await api.changePassword(changePwUser.user_id, currentPw, newPw.trim())
      setTokens(res.token, res.refresh_token, res.user)
      onLogin(res.user)
    } catch (err) {
      setError(err.message || '비밀번호 변경에 실패했습니다.')
    } finally {
      setLoading(false)
    }
  }

  if (changePw) {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-header">
            <span className="login-logo">◆</span>
            <h1 className="login-title">비밀번호 변경</h1>
          </div>
          <p className="login-notice">
            {changePwUser?.last_name}{changePwUser?.first_name}님, 최초 로그인 시 비밀번호를 변경해야 합니다.
          </p>
          <form className="login-form" onSubmit={handleChangePassword}>
            <label className="login-label" htmlFor="new-pw">새 비밀번호</label>
            <input id="new-pw" className="login-input" type="password"
              placeholder="영문 + 숫자 + 특수문자, 8자 이상"
              value={newPw} onChange={(e) => setNewPw(e.target.value)} autoFocus />
            <label className="login-label" htmlFor="new-pw2">새 비밀번호 확인</label>
            <input id="new-pw2" className="login-input" type="password"
              placeholder="새 비밀번호를 다시 입력하세요"
              value={newPwConfirm} onChange={(e) => setNewPwConfirm(e.target.value)} />
            {error && <div className="login-error">{error}</div>}
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? '변경 중...' : '비밀번호 변경'}
            </button>
          </form>
          <button className="login-back-btn" onClick={() => { setChangePw(false); setError('') }}>
            ← 로그인으로 돌아가기
          </button>
          <p className="login-footer">KB금융그룹 데이터분석플랫폼</p>
        </div>
      </div>
    )
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <span className="login-logo">◆</span>
          <h1 className="login-title">DAVIS Semantic View Studio</h1>
        </div>
        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-label" htmlFor="login-id">사번</label>
          <input id="login-id" className="login-input" type="text"
            placeholder="사번을 입력하세요"
            value={userId} onChange={(e) => setUserId(e.target.value)} autoFocus />
          <label className="login-label" htmlFor="login-pw">비밀번호</label>
          <input id="login-pw" className="login-input" type="password"
            placeholder="비밀번호를 입력하세요"
            value={password} onChange={(e) => setPassword(e.target.value)} />
          {error && <div className="login-error">{error}</div>}
          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>
        <p className="login-footer">KB금융그룹 데이터분석플랫폼</p>
      </div>
    </div>
  )
}
